import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//数据字典
export const dictionaryprovince= params=> {return addinstance().get(geturl(`/dictionary/province`),{params:params});}
export const dictionarycity= params=> {return addinstance().get(geturl(`/dictionary/city`),{params:params});}
export const dictionaryzone= params=> {return addinstance().get(geturl(`/dictionary/zone`),{params:params});}








// WEBPACK FOOTER //
// ./src/api/dictionary.js